<template>
  <div>
    <div v-if="cargando" class="mt-5">
      <div class="d-flex justify-content-center">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      <p class="text-center mt-4">Espere mientras se verifica su información</p>
    </div>
    <div v-else>
      <div class="alert alert-info" v-if="mensaje !== null">{{ mensaje }}</div>
      <BazarLogin v-if="login" @actualiza="setDatosUsuario" :emp="emp"/>
      <div v-else>
        <nav class="navbar fixed-top navbar-expand-lg navbar-light mb-3 bg-light">
          <a class="navbar-brand" href="#">{{ emp.nombre }}</a>
          <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>

          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ml-auto" v-if="usuario != null">
              <li class="nav-item" v-if="emp.login.bazar_modo_id == 1">
                <a class="nav-link" href="javascript:;"><b>Saldo disponible Q. {{ usuario.saldo_disponible }}</b></a>
              </li>
              <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  {{ usuario.nombre }}
                </a>
                <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                  <li>
                    <a
                      class="dropdown-item"
                      href="#"
                      @click.prevent="verAhorrosAcumulados"
                    >Ahorros Acumulados</a>
                  </li>
                  <li>
                    <a
                      class="dropdown-item"
                      href="#"
                      @click.prevent="verObligaciones"
                    >Compras {{ emp.dominio.toUpperCase() }}</a>
                  </li>
                  <li>
                    <a class="dropdown-item" href="#" @click.prevent="cerrar">Cerrar sesión</a>
                  </li>
                </div>
              </li>
            </ul>
            <form class="form-inline my-2 my-lg-0">
              <button class="btn btn-secondary mr-2 px-4" type="button" @click="opcion = 3">
                <i class="fas fa-shopping-cart mr-2"></i> Ver carrito
                <span class="badge badge-light ml-2"> {{ totalProductos }} </span>
              </button>
            </form>
          </div>
        </nav>
        <br><br><br>
        <div class="container-fluid">
          <keep-alive>
            <BazarProveedor 
              v-if="opcion == 1" 
              :emp="emp" 
              @actSaldo="actualizaSaldo"
              @setProveedor="setProveedor"/>
          </keep-alive>

          <div class="row" v-if="opcion == 2">
            <div class="col-sm-2 mb-2">
              <button 
                type="button" 
                class="btn btn btn-outline-secondary btn-block mb-2" 
                @click="regresar" 
                title="Regresar"
              >
                <i class="fa fa-arrow-left"></i> Regresar
              </button>
              <div class="card" v-if="config && prov.logo !== null">
                <img 
                  class="card-img-top" 
                  :src="UrlImgDrive+prov.logo" 
                  :alt="emp.empresa"
                >
              </div>
              <ul class="nav nav-pills flex-column mt-2">
                <li class="nav-item">
                  <a 
                    class="nav-link" 
                    :class="{'active rounded-pill': buscar.categoria == 'TODOS'}"
                    href="javascript:;"
                    @click.prevent="getProductos('TODOS')"
                  > TODO </a>
                </li>
                <li class="nav-item" v-for="(i, index) in categorias" :key="index">
                  <a 
                    class="nav-link" 
                    :class="{'active rounded-pill': (buscar.categoria == i.id)}"
                    href="javascript:;" 
                    @click.prevent="getProductos(i.id)"
                  >
                    {{ i.descripcion }}
                  </a>
                </li>
              </ul>
            </div>
            <div class="col-sm-10 bg-light border rounded">
              <div class="row mb-3">
                <div class="col-sm-12">
                  <h2 class="d-inline-block font-weight-normal text-center">{{ prov.descripcion }}</h2>
                </div>
                <div class="col-sm-12" v-if="lista.length > 0">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text" id="buscar-termino">
                        <i class="fas fa-search"></i>
                      </span>
                    </div>
                    <input 
                      type="search" 
                      class="form-control" 
                      placeholder="Buscar" 
                      aria-label="Buscar" 
                      v-model="termino"
                      aria-describedby="buscar-termino"
                    >
                  </div>
                  </div>
              </div>
              <div v-if="cargaPro && buscar.inicio == 0">
                <div class="d-flex justify-content-center">
                  <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
                <p class="text-center mt-3">Cargando los productos...</p>
              </div>
              <div v-else class="row">
                <div class="col-sm-4 mb-4" v-for="(item,index) in filtrada" :key="item.id">
                  <div 
                    class="card h-100"
                    :class="item.sombra"
                    @mouseover="item.sombra = 'shadow'"
                    @mouseleave="item.sombra = ''"
                  >
                    <img 
                      v-if="item.imagen !== null"
                      :src="item.imagen" 
                      class="card-img-top" 
                      :alt="item.nombre" 
                    >
                    <div class="card-body">
                      <h5 class="card-title">
                        <a 
                          href="javascript:;"
                          @click="mostrarModal(index)" 
                        >{{ item.nombre }}</a>
                      </h5>
                      <p class="card-text">
                        <span class="text-muted">{{ item.categoria_uno }}</span><br>
                        <strong>Q {{ item.presentacion_seleccionada == '' ? item.precio : item.presentacion_seleccionada.precio }}</strong><br>
                        {{ item.descripcion }}
                      </p>
                    </div>
                    <div class="card-footer">
                      <BazarForm :producto="item" :emp="emp" @actTotal="actualiza_total"/>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 mb-4 text-center">
                  <span v-if="textoMas">Espere, se estan cargando más productos</span>
                  <span v-else>
                    <a href="#" @click.prevent="cargarMas()" v-if="hayTmp >= 12"><b>Cargar más...</b></a>
                  </span>
                </div>
              </div>  
            </div>
          </div>

          <BazarCarro 
            v-if="opcion == 3"
            :emp="emp"
            @regresar="opcion = 1"
            @actTotal="actualiza_total"
            @actSaldo="actualizaSaldo"/>
          <div 
            class="modal fade" 
            tabindex="-1" 
            role="dialog" 
            id="mdlCartaProducto" 
          >
            <div class="modal-dialog modal-xl modal-dialog-scrollable">
              <div class="modal-content">
                <div class="modal-header" v-if="producto !== null">
                  <h5 class="modal-title">{{ producto.nombre }}</h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body" v-if="producto !== null">
                  <BazarModal 
                    :producto="producto"
                    :emp="emp"
                    @actTotal="actualiza_total"
                  ></BazarModal>
                </div>
                <div class="modal-footer">
                  <button 
                    type="button" 
                    class="btn btn-secondary" 
                    data-dismiss="modal"
                  >Cerrar</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal" tabindex="-1" id="mdlAhorrosAcumulados">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Ahorros Acumulados</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form class="form-inline" @submit.prevent="getAhorrosAcumulados">
              <div class="form-group mr-sm-3 mb-2">
                <label for="inputECanio" class="mr-sm-3">Año</label>
                <input
                  type="number"
                  v-model="cuenta.form.anio"
                  class="form-control"
                  id="inputECanio"
                >
              </div>
              <button type="submit" class="btn btn-primary mb-2" :disabled="cuenta.cargando">
                <template v-if="cuenta.cargando">
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  Buscando...
                </template>
                <template v-else>Buscar</template>
              </button>
            </form>
          </div>
          <div class="table-responsive" v-if="cuenta.lista.length > 0">
            <table class="table table-striped table-sm">
              <thead>
                <tr>
                  <th scope="col">Mes</th>
                  <th class="text-right">Monto</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(i, idx) in cuenta.lista" :key="idx">
                  <td scope="row">{{ i.mes_nombre.toUpperCase() }}</td>
                  <td class="text-right">{{ parseFloat(i.monto).toLocaleString('en-US') }}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <th scope="row">TOTAL DE APORTES LABORALES</th>
                  <td class="text-right">{{ parseFloat(cuenta.total).toLocaleString('en-US') }}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="modal" tabindex="-1" id="mdlObligaciones">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Compras {{ emp.dominio.toUpperCase() }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form class="form-inline" @submit.prevent="getObligaciones">
              <div class="form-group mr-sm-3 mb-2">
                <label for="inputOBanio" class="mr-sm-3">Año:</label>
                <input
                  type="number"
                  v-model="obligacion.form.anio"
                  class="form-control"
                  id="inputOBanio"
                  required
                >
              </div>
              <div class="form-group mr-sm-3 mb-2">
                <label for="selectOBmes" class="mr-sm-3">Mes:</label>
                <select
                  class="form-control"
                  v-model="obligacion.form.mes"
                  id="selectOBmes"
                  required
                >
                  <option value="">-----</option>
                  <option v-for="(i, idx) in meses" :key="idx" :value="i.id">{{ i.nombre }}</option>
                </select>
              </div>
              <button type="submit" class="btn btn-primary mb-2" :disabled="obligacion.cargando">
                <template v-if="obligacion.cargando">
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  Buscando...
                </template>
                <template v-else>Buscar</template>
              </button>
            </form>
          </div>
          <div class="table-responsive" v-if="obligacion.lista.length > 0">
            <table class="table table-striped table-sm">
              <thead>
                <tr>
                  <th scope="col">Tipo</th>
                  <th class="text-right">Saldo Anterior</th>
                  <th class="text-right">Descuento Mes</th>
                  <th class="text-right">Saldo</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(i, idx) in obligacion.lista" :key="idx">
                  <td scope="row">{{ i.tipo }}</td>
                  <td class="text-right">{{ parseFloat(i.saldo_anterior).toLocaleString('en-US') }}</td>
                  <td class="text-right">{{ parseFloat(i.descuento).toLocaleString('en-US') }}</td>
                  <td class="text-right">{{ parseFloat(i.saldo).toLocaleString('en-US') }}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <th scope="row">TOTAL</th>
                  <td class="text-right">{{ parseFloat(obligacion.total_saldo_anterior).toLocaleString('en-US') }}</td>
                  <td class="text-right">{{ parseFloat(obligacion.total_descuento).toLocaleString('en-US') }}</td>
                  <td class="text-right">{{ parseFloat(obligacion.total_saldo).toLocaleString('en-US') }}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import BazarForm from './components/BazarForm.vue';
  import BazarLogin from './components/BazarLogin.vue';
  import BazarModal from './components/BazarModal.vue';
  import BazarCarro from './components/BazarCarro.vue';
  import BazarProveedor from './components/BazarProveedor.vue';

  import axios from 'axios';
  import $ from 'jquery';

  export default {
    name: 'App',
    data: () => ({
      cargaPro: false,
      cargando: true,
      mensaje: null,
      categorias: [],
      login: false,
      lista: [],
      hayTmp: 0,
      termino: null,
      opcion: 1,
      config: null,
      prov: null,
      producto: null,
      textoMas:false,
      totalProductos: 0,
      buscar: {
        categoria: 'TODOS',
        inicio: 0
      },
      emp: {
        dominio: 'C807',
        nombre: null,
        config: null
      },
      usuario: null,
      cuenta: {
        form: {
          anio: ''
        },
        lista: [],
        total: 0,
        cargando: false
      },
      obligacion: {
        form: {
          anio: '',
          mes: ''
        },
        lista: [],
        total_saldo_anterior: 0,
        total_descuento: 0,
        total_saldo: 0,
        cargando: false
      },
      meses: [
        { id: 1, nombre: 'Enero' },
        { id: 2, nombre: 'Febrero' },
        { id: 3, nombre: 'Marzo' },
        { id: 4, nombre: 'Abril' },
        { id: 5, nombre: 'Mayo' },
        { id: 6, nombre: 'Junio' },
        { id: 7, nombre: 'Julio' },
        { id: 8, nombre: 'Agosto' },
        { id: 9, nombre: 'Septiembre' },
        { id: 10, nombre: 'Octubre' },
        { id: 11, nombre: 'Noviembre' },
        { id: 12, nombre: 'Diciembre' }
      ]
    }),
    created () {
      this.validaUsuario();
    },
    methods: {
      validaUsuario() {
        axios
        .get(this.UrlBase+'/bazar/valida_usuario')
        .then(res => {
          if (res.data.bazar) {
            this.emp = res.data.bazar;
            this.mensaje = null;
            let credenciales = localStorage.getItem('bazar_'+this.emp.dominio);

            this.login = !credenciales;
            if (this.login !== null) {
              this.get_datos();
            }

          } else {
            this.mensaje = "No tiene acceso a ninguna empresa.";
          }

        }).catch(e => {
          this.cargando = false;
          alert(e);
        });
      },
      setDatosUsuario (valor) {
        this.login = valor.login;
        this.usuario = valor.usuario;
        this.get_datos();
      },
      setProveedor (valor) {
        this.lista = [];
        this.categorias = [];
        this.hayTmp = 0; 
        this.prov = valor.prov.padre;
        this.config = valor.config;
        this.opcion = 2;

        axios
        .get(this.UrlBase+'/bazar/get_categorias/'+this.prov.id)
        .then(res => {
          this.categorias = res.data.lista;

          this.buscar.categoria = 'TODOS';
          this.getProductos();
        }).catch(e => {
          alert('Categorias '+e);
        });
      },
      getProductos(id) {
        this.cargaPro = true;
        this.textoMas = true;

        if (id) {
          this.buscar.categoria = id;
        }
        if (this.buscar.categoria == 'TODOS') {
          this.buscar.principal = this.prov.id;
        }

        axios
        .get(this.UrlBase+'/bazar/get_productos', {params:this.buscar})
        .then(res => {
          if (this.buscar.inicio == 0) {
            this.lista = res.data.lista;
            this.hayTmp = res.data.lista.length; 
          } else {
            res.data.lista.forEach(e => {
              this.lista.push(e);
            })
          }
          this.cargaPro = false;
          this.textoMas = false;
        }).catch(e => {
          this.cargaPro = false;
          this.textoMas = false;
          alert('Productos '+e);
        });
      },
      regresar () {
        this.prov = null;
        this.config = null;
        this.opcion = 1;
      },
      cargarMas() {
        this.buscar.inicio += this.hayTmp;
        this.getProductos();
      },
      mostrarModal (idx) {
        this.producto = this.filtrada[idx];
        $('#mdlCartaProducto').modal('toggle');
      },
      cerrar () {
        axios
        .get(this.UrlBase+'/bazar/salir/'+this.emp.dominio)
        .then(res => {
          if (res.data.exito) {
            localStorage.removeItem('bazar_'+this.emp.dominio);
            location.reload();
          }
        }).catch(e => {
          alert('salir '+e)
        });
      },
      get_datos() {
        let header = JSON.parse(localStorage.getItem(`bazar_${this.emp.dominio}`))
        if (header) {
          axios.defaults.headers = {
            Authorization: header.token
          }
          axios
          .get(this.UrlBase+'/bazar/get_datos_bazar')
          .then(res => {
            if (res.data.exito) {
              this.usuario = res.data.usuario;
              this.totalProductos = res.data.totalProductos;
            } else {
              this.login = true;
            }
            this.cargando = false;
          }).catch(e => {
            this.cargando = false;
            alert('Info usuario '+e);
          });
        } else {
          this.cargando = false;
        }
      },
      actualiza_total(valor, modo) {
        if (modo) {
          this.totalProductos += parseInt(valor);
        } else {
          this.totalProductos -= parseInt(valor);
        }
      },
      actualizaSaldo (valor) {
        this.usuario.saldo_disponible = valor;
      },
      getAhorrosAcumulados () {
        this.cuenta.cargando = true;
        this.cuenta.lista = []
        this.cuenta.total = 0

        axios
        .get(this.UrlBase+'/bazar/saldo', {params: this.cuenta.form})
        .then(res => {
          this.cuenta.lista = res.data.lista
          this.cuenta.total = res.data.total
          this.cuenta.cargando = false;
        }).catch(e => {
          this.cuenta.cargando = false;
          alert('Info usuario '+e);
        });
      },
      verAhorrosAcumulados () {
        if (this.cuenta.form.anio === '') {
          const fec = new Date()
          this.cuenta.form.anio = fec.getFullYear()
        }
        
        $('#mdlAhorrosAcumulados').modal()
      },
      getObligaciones () {
        this.obligacion.cargando = true;
        this.obligacion.lista = []
        this.obligacion.total_saldo_anterior = 0
        this.obligacion.total_descuento = 0
        this.obligacion.total_saldo = 0

        axios
        .get(this.UrlBase+'/bazar/obligacion', {params: this.obligacion.form})
        .then(res => {
          this.obligacion.lista = res.data.lista
          this.obligacion.total_saldo_anterior = res.data.total_saldo_anterior
          this.obligacion.total_descuento = res.data.total_descuento
          this.obligacion.total_saldo = res.data.total_saldo
          this.obligacion.cargando = false;
        }).catch(e => {
          this.obligacion.cargando = false;
          alert('Info usuario '+e);
        });
      },
      verObligaciones () {
        const fec = new Date()

        if (this.obligacion.form.anio === '') {
          this.obligacion.form.anio = fec.getFullYear()
        }

        if (this.obligacion.form.mes === '') {
          this.obligacion.form.mes = fec.getMonth()
        }
        
        $('#mdlObligaciones').modal()
      }
    },
    computed: {
      filtrada () {
        if (this.termino) {
          return this.lista.filter(o => {
            return o.descripcion.toLowerCase().includes(this.termino.toLowerCase())
          });
        } else {
          return this.lista;
        }
      }
    },
    watch: {
      'buscar.categoria' () {
        this.hayTmp = 0;
        this.buscar.inicio = 0;
      }
    },
    components: {
      BazarForm,
      BazarLogin,
      BazarModal,
      BazarCarro,
      BazarProveedor
    }
  }
</script>
<style>
.nav-pills .nav-link.active, .nav-pills .show > .nav-link {
  color: rgb(17, 106, 101);
  background-color: rgba(28, 176, 168, 0.2);
}
</style>
